(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('currency-journal', {
            parent: 'entity',
            url: '/currency-journal',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.currencyJournal.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/currency-journal/currency-journals.html',
                    controller: 'CurrencyJournalController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('currencyJournal');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('currency-journal-detail', {
            parent: 'entity',
            url: '/currency-journal/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.currencyJournal.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/currency-journal/currency-journal-detail.html',
                    controller: 'CurrencyJournalDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('currencyJournal');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CurrencyJournal', function($stateParams, CurrencyJournal) {
                    return CurrencyJournal.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('currency-journal.new', {
            parent: 'currency-journal',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/currency-journal/currency-journal-dialog.html',
                    controller: 'CurrencyJournalDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                activeFrom: null,
                                activeUntil: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('currency-journal', null, { reload: true });
                }, function() {
                    $state.go('currency-journal');
                });
            }]
        })
        .state('currency-journal.edit', {
            parent: 'currency-journal',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/currency-journal/currency-journal-dialog.html',
                    controller: 'CurrencyJournalDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CurrencyJournal', function(CurrencyJournal) {
                            return CurrencyJournal.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('currency-journal', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('currency-journal.delete', {
            parent: 'currency-journal',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/currency-journal/currency-journal-delete-dialog.html',
                    controller: 'CurrencyJournalDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CurrencyJournal', function(CurrencyJournal) {
                            return CurrencyJournal.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('currency-journal', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
